
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/dnd.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-dnd-demo-plugin-dnd"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/dnd.zh.md?type=demo')
};